import Image from 'next/image';

import { Box, List, ListItem, Text } from '@chakra-ui/react';

import { ContentContainer } from '~/components/container';

const countries: Array<{
  name: string;
  imgSrc: string;
}> = [
  {
    name: 'United States',
    imgSrc: '/images/united-states.svg',
  },
  {
    name: 'Chile',
    imgSrc: '/images/chile.svg',
  },
  {
    name: 'United Arab Emirates',
    imgSrc: '/images/united-arab-emirates.svg',
  },
  {
    name: 'Jordan',
    imgSrc: '/images/jordan.svg',
  },
  {
    name: 'Oman',
    imgSrc: '/images/oman.svg',
  },
  {
    name: 'Egypt',
    imgSrc: '/images/egypt.svg',
  },
  {
    name: 'Saudi Arabia',
    imgSrc: '/images/saudi-arabia.svg',
  },
  {
    name: 'Uzbekistan',
    imgSrc: '/images/uzbekistan.svg',
  },
  {
    name: 'European Union',
    imgSrc: '/images/european-union.svg',
  },
];

export function CountriesSection() {
  return (
    <Box
      as='section'
      padding={{
        base: '40px 0px',
        md: '48px 0px',
      }}
    >
      <ContentContainer>
        <List
          display='grid'
          gridTemplateColumns='repeat(auto-fit, minmax(64px, 1fr))'
          gridGap={{
            base: '40px 48px',
            md: '48px',
          }}
        >
          {countries.map((country) => (
            <ListItem
              key={country.name}
              alignItems='center'
              display='flex'
              flexDir='column'
              gap='16px'
              flex={{
                base: '0 0 64px',
                md: '0 0 81px',
              }}
            >
              <Image alt='' height={64} src={country.imgSrc} width={64} />
              <Text fontWeight='600' size='caption' textAlign='center'>
                {country.name}
              </Text>
            </ListItem>
          ))}
        </List>
      </ContentContainer>
    </Box>
  );
}
